<!--
通用普通页面模板
-->
<style lang="less">
  .fan-curd-modal{
    :deep(.arco-modal-header){
      padding: 15px 20px;
    }
    :deep(.arco-modal-body){
      max-height: 800px; padding: 20px; overflow-x: hidden; overflow-y: auto;
    }
  }
</style>
<style lang="less" scoped>
  @import "~@/public/less/index.less";
  .f-plugin-list{
    width: 100%; height: 100% !important; overflow: hidden;
    .head{
      margin: 0 20px 20px 20px; font-size: 1.1em; font-weight: bold;
    }
    .subHead{
      margin: 0 20px 20px 20px;
    }
  }
</style>
<template>
  <div class="fan fan-component f-plugin-list">
    <f-layout ref="zlayout"
              v-if="superApi"
              :superPage="superPage"
              :superApi="superApi"
              @reloadData="reloadData">
      <!-- 面包屑 -->
      <template #breadcrumb><div></div></template>
      <!-- 头部 -->
      <template #head v-if="superTitle || $slots.subHead">
        <div class="head" v-if="superTitle && returnUrl && returnUrl.url!=='/'">
          <div class="return" @click="$fan.page.open(returnUrl.url, returnUrl.query)">
            <icon-left /> {{superTitle || router.info.name}}
          </div>
        </div>
        <div class="subHead" v-if="$slots.subHead"><slot name="subHead"></slot></div>
      </template>
      <!-- 检索 -->
      <template #subHeadLeft v-if="$slots.subHeadLeft">
        <slot name="subHeadLeft"></slot>
      </template>
      <!-- 按钮组 -->
      <template #subHeadRight v-if="$slots.subHeadRight">
        <slot name="subHeadRight"></slot>
      </template>
      <!-- 子菜单（仅5级以上显示） -->
      <template #menus v-if="menus && Object.keys(menus).length>1 && router.info.level >= 5">
        <a-menu mode="inline"
                :style="{ height: '100%', borderRight: 0 }"
                :defaultOpenKeys="[`${router.topInfo.url}`]"
                :defaultSelectedKeys="[`${router.info.url}`]">
          <template v-for="(item, index) in menus">
            <a-sub-menu :key="index"
                        v-if="item.info.show &&
                              item.info.type==='menu' &&
                              item.info.level===(router.navInfo.level+1) &&
                              !item.info.hasTmp && item.info.hasChild">
              <template #title>
                <component :is="'icon-' + item.info.icon" />
                <span>{{item.info.name}}</span>
              </template>
              <template v-for="(item2, index2) in menus">
                <a-menu-item :key="index2"
                             v-if="item2.info.type==='menu' &&
                                   item2.topInfo.url===item.info.url &&
                                   item2.info.level===(router.navInfo.level+2)"
                             @click="$fan.page.open(index2, query)">
                    <span>
                      <component :is="'icon-' + item2.info.icon" />
                      <span>{{item2.info.name}}</span>
                    </span>
                </a-menu-item>
              </template>
            </a-sub-menu>
            <a-menu-item :key="'menu-' + index"
                         v-else-if="item.info.show &&
                                    item.info.level===(router.navInfo.level+1) &&
                                    item.info.hasTmp"
                         @click="$fan.page.open(index, query)">
                  <span>
                    <component :is="'icon-' + item.info.icon" />
                    <span>{{item.info.name}}</span>
                  </span>
            </a-menu-item>
          </template>
        </a-menu>
      </template>
      <!-- 主体内容 -->
      <template #body v-if="$slots.body">
        <slot name="body"></slot>
      </template>
      <!-- 主体内容 -->
      <template #main v-if="$slots.main">
        <slot name="main"></slot>
      </template>
      <!-- 附属内容 -->
      <template #minor v-if="$slots.minor">
        <slot name="minor"></slot>
      </template>
    </f-layout>
    <!--
      全局弹窗式新增编辑查看窗口
    -->
    <div id="modal" v-if="page.modal">
      <a-modal
          class="fan-curd-modal"
          v-model:visible="page.modal.visible"
          :width="page.modal.width"
          align-center unmount-on-close

      >
        <template #title>
          <template v-if="$slots.modalTitle">
            <slot name="modalTitle" />
          </template>
          <template v-else>
            {{page.modal.title}}
          </template>
        </template>
        <template #footer>
          <slot name="modalFooter" />
          <a-button v-if="page.modal.title==='详情'" @click="$refs.detail.actionDetailPrint()"><template #icon><icon-printer /></template>打印</a-button>
          <a-button v-if="page.modal.title!=='详情'" type="primary" @click="$refs.form.actionFormSubmit()"><template #icon><icon-check /></template>提交</a-button>
        </template>
        <f-report ref="detail"
                  v-if="page.modal.title==='详情'"
                  :superApi="superApi"
                  :superData="page.modal.data"
                  :template="template"
                  mold="detail"
                  :mixData="mixData"
                  @emitOpenDrawer="bindOpenModal"
                  @emitCloseDrawer="bindCloseModal"
                  @emitReloadData="reloadData">
        </f-report>
        <f-report ref="form"
                  v-else-if="page.modal.title==='编辑'"
                  :superApi="superApi"
                  :superData="page.modal.data"
                  :template="template"
                  mold="edit"
                  :mixData="mixData"
                  @bindFormSubmit="bindFormSubmit"
                  @emitOpenDrawer="bindOpenModal"
                  @emitCloseDrawer="bindCloseModal"
                  @emitReloadData="reloadData">
        </f-report>
        <f-report ref="form"
                  v-else-if="page.modal.title==='新增'"
                  :superApi="superApi"
                  :superData="page.modal.data"
                  :template="template"
                  mold="add"
                  :mixData="mixData"
                  @bindFormSubmit="bindFormSubmit"
                  @emitOpenDrawer="bindOpenModal"
                  @emitCloseDrawer="bindCloseModal"
                  @emitReloadData="reloadData">
        </f-report>
        <div v-else>未知modal类型</div>
        <form ref="pdf" action="http://pdf.119.7jj.org.cn/" method="POST" target="_blank" v-show="false">
          <input type="hidden" name="payload" :value="page.printData" />
        </form>
      </a-modal>
    </div>
  </div>
</template>

<script>
  import { IconLeft, IconPrinter, IconCheck } from '@arco-design/web-vue/es/icon'

  export default {
    name: 'ZPluginList',
    components: { IconLeft, IconPrinter, IconCheck },
    props: {
      superTitle: String,
      superPage: Object,
      superApi: String,
      template: String,
      mixData: Object
    },
    created() {
      this.page = this.$fan.utils.parse(this.def.page)
      this.data = this.$fan.utils.parse(this.def.data)
    },
    data() {
      return {
        page: {}, data: {},
        def: {
          page: {
            modal: {
              width: '900px',
              visible: false,
              title: '详情',
              data: Object
            }
          },
          data: {}
        }
      }
    },
    computed: {
      routers() {
        return this.$store.state.routers || {}
      },
      router() {
        return this.routers[this.$route.path] || {}
      },
      menus() {
        let menus = {}
        if (this.router && this.router.navInfo && this.router.navInfo.hasChild) {
          for (let k in this.routers) {
            const router = this.routers[k]
            let routerNavUrl = ""
            for (let i =0; i < this.router.navInfo.level; i++) {
              routerNavUrl = routerNavUrl+"/"+router.info.path[i]
            }
            if (router.info.type!=='nav' && routerNavUrl===this.router.navInfo.url) {
              menus[router.info.url] = router
            }
          }
        }
        return Object.keys(menus).length>0 ? menus : false
      },
      query() {
        const query = this.$route.query
        if (this.$fan.utils.notEmpty(query)) {
          return query
        } else {
          return false
        }
      },
      returnUrl() {
        const breadcrumb = this.router.info.breadcrumb
        if (breadcrumb.length > 2) {
          let returnUrl = {name: "首页", icon: "home", url: "/", query: {}}
          if (breadcrumb[breadcrumb.length-2] && this.routers[breadcrumb[breadcrumb.length-2].url].info.hasTmp) {
            returnUrl = breadcrumb[breadcrumb.length-2]
          } else if (breadcrumb[breadcrumb.length-3] && this.routers[breadcrumb[breadcrumb.length-3].url].info.hasTmp) {
            returnUrl = breadcrumb[breadcrumb.length-3]
          } else if (breadcrumb[breadcrumb.length-4] && this.routers[breadcrumb[breadcrumb.length-4].url].info.hasTmp) {
            returnUrl = breadcrumb[breadcrumb.length-4]
          }
          const query = this.$fan.storage.getStorage('fan-page_query', this.router.topInfo.url)
          returnUrl.query = query
          return returnUrl
        } else {
          return {name: "首页", icon: "home", url: "/", query: {}}
        }
      },
    },
    methods: {
      reloadData() {
        this.$emit('reloadData')
      },
      // 控制modal
      bindOpenCurdModal(title='详情', data={record:{}}) {
        this.page.modal.title = title
        this.page.modal.data = data.record
        this.bindOpenModal()
      },
      bindOpenModal(e) {
        this.page.modal.visible = true
      },
      async bindCloseModal(e) {
        this.page.modal.visible = false
      },
      bindFormSubmit(mold, form) {
        this.$emit('bindFormSubmit', mold, form, this.page.modal.data)
      },
      async bindFormSubmitDo(api, mold, req) {
        if (mold === 'add') {
          const {data} = await this.$fan.api.post(`${api}`, req)
          if (data && data.data && data.data>0) {
            this.reloadData()
            this.bindCloseModal()
          }
        } else if (mold === 'edit') {
          const {data} = await this.$fan.api.put(`${api}/${this.page.modal.data.id}`, req)
          if (data && data.data && data.data>0) {
            this.reloadData()
            this.bindCloseModal()
          }
        }
      }
    }
  }
</script>
